import { useState } from "react";
import logger from "@airhelp/node-logger";
import { useTranslations } from "contexts/LocalizationContext/hooks";
import { FormSuccessMessage } from "components/FormControl";
import { Flex, Heading, Box } from "@chakra-ui/react";
import type { SbEditableComponentProps } from "types/storyblok";
import { trackCustomEvent } from "utils/tracking";
import SubscribeForm from "./SubscribeForm";
import type { SubscribeProps } from "./Subscribe.d";

const Subscribe = ({
  heading,
  text,
  buttonText,
  listId = "blog",
  fullWidth,
  mobileView,
  sbEditable,
}: SbEditableComponentProps<SubscribeProps>) => {
  const [hasSubscribed, setHasSubscribed] = useState(false);
  const translations = useTranslations();
  const width = fullWidth ? "full" : "60%";

  const SUBSCRIBE_EVENTS = {
    blog: { event: "newsletter", placement: listId } as const,
    partner: { event: "submit_contact", label: "form_submission", type: listId } as const,
  };

  const subscribeEvent = SUBSCRIBE_EVENTS[listId];

  if (!subscribeEvent) logger.error(`List ID is not configured for the subscribe tracking: ${listId}`);
  if (hasSubscribed && subscribeEvent) trackCustomEvent(subscribeEvent);

  return (
    <Flex flexDir="column" align="flex-start" color="white" py={6} {...sbEditable}>
      <Heading color="inherit" variant="h2" as="h2" pb={2} w={{ base: "full", lg: width }} textAlign="left">
        {heading}
      </Heading>
      <Box w={{ base: "full", lg: width }} textAlign="left">
        {text}
      </Box>
      {!hasSubscribed ? (
        <SubscribeForm
          setHasSubscribed={setHasSubscribed}
          buttonText={buttonText}
          listId={listId}
          fullWidth={fullWidth}
          mobileView={mobileView}
        />
      ) : (
        <FormSuccessMessage text={translations("subscribe_form_submit_succesful")} />
      )}
    </Flex>
  );
};

export default Subscribe;
